export default __webpack_public_path__ + "static/media/circlexmark-1.00f97280.svg";